/* eslint-disable global-require */
// config for tabs
export const questions = [
  {
    results: ['C', 'Z'],
    text: 'Ich erledige oft mehrere Dinge auf einmal.',
  },
  {
    results: ['Z'],
    text: 'Ich lasse mich leicht ablenken.',
  },
  {
    results: ['Pr'],
    text: 'Wenn ich Dinge zu erledigen habe, kann ich mich häufig nicht dazu aufraffen, anzufangen.',
  },
  {
    results: ['Pe'],
    text: 'Ich will alle Fakten wissen, bevor ich etwas anfange oder mich entscheide.',
  },
  {
    results: ['E'],
    text: 'Wenn mich jemand um einen Gefallen bittet, helfe ich meistens.',
  },
  {
    results: ['S'],
    text: 'Ich chatte viel mit Freunden oder verbringe viel Zeit mit Telefonieren.',
  },
  {
    results: ['Pe', 'Z'],
    text: 'Ich brauche für viele Aufgaben länger als erwartet.',
  },
  {
    results: ['Pr'],
    text: 'Ich verschiebe häufig Vorhaben oder Aufgaben.',
  },
  {
    results: ['S'],
    text: 'Ich bin über jeden Flurfunk informiert.',
  },
  {
    results: ['Z'],
    text: 'Wenn ich mein Handy in die Hand nehme, komme ich oft vom Hundertsten ins Tausendste und „verdattele“ meine Zeit.',
  },
  {
    results: ['C'],
    text: 'Mein Schreibtisch ist unaufgeräumt und wirkt unordentlich.',
  },
  {
    results: ['Pr'],
    text: 'Ich erledige Dinge häufig auf den letzten Drücker.',
  },
  {
    results: ['E'],
    text: 'Ich betrachte Erledigungen für andere oftmals wichtiger als meine eigenen.',
  },
  {
    results: ['S', 'E'],
    text: 'Zeit mit Menschen zu verbringen gibt mir ein besseres Gefühl als die Erledigung von Aufgaben.',
  },
  {
    results: ['C'],
    text: 'Ich verchecke immer mal wieder Termine oder Geburtstage.',
  },
  {
    results: ['Pe'],
    text: 'Ich verliere mich häufig in der Umsetzung kleiner Details.',
  },
  {
    results: ['E'],
    text: 'Gefallen für andere erledige ich meistens vor meinen eigenen ToDos.',
  },
  {
    results: ['S'],
    text: 'Ich verbringe gerne Zeit mit Small Talk.',
  },
  {
    results: ['Pr'],
    text: 'Ich kann nur unter Zeitdruck gut arbeiten.',
  },
  {
    results: ['C'],
    text: 'Ich verlege oder suche häufiger etwas.',
  },
  {
    results: ['Pe'],
    text: 'Wenn ich eine Aufgabe angehe, gebe ich immer mindestens 100%.',
  },
];

export const resultOptions = {
  C: {
    caption: 'Chaotino',
    image: require('../assets/chaotino.png'),
    behaviours: ['Du musst häufig etwas suchen', 'Du verbringst viel Zeit mit Aufräumen', 'Auf deinem Schreibtisch gibt es viele Stapel / Unordnung'],
    solutions: ['Ablagesystem optimieren', 'Dinge sofort aufräumen, festen Ort definieren', 'Schreibe alles auf, was durch deinen Kopf schwirrt, um Platz für andere Dinge zu schaffen'],
  },
  E: {
    caption: 'Empathino',
    image: require('../assets/empathino.png'),
    behaviours: ['Du hilfst gerne anderen', 'Du kannst schlecht „nein“ sagen'],
    solutions: ['Übe „nein“ zu sagen. Beginne im Kleinen (z.B. mit Partner bei unwichtigen Kleinigkeiten)', 'Achte auf deine eigenen Prioritäten', 'Mache dir klar, dass du nur aus einem vollen Glas schöpfen kannst. Du solltest deine erste Priorität sein, um anschließend anderen helfen zu können.'],
  },
  Pe: {
    caption: 'Perfektino',
    image: require('../assets/perfektino.png'),
    behaviours: ['Du gibst bei allem mindestens 100%', 'Du kannst Dinge nicht unperfekt erledigen'],
    solutions: ['Pareto-Prinzip  anwenden: 80% der Aufgabe sind in 20% der Zeit erledigt, die restlichen 20% der Aufgabe gut sein lassen', 'Vorher Zeitlimits für Aufgaben festlegen und Aufgabe nur maximal so lange bearbeiten', '„Done is better than perfect“: Aufgabe erst grob erledigen, eventuelle Verbesserungen können im Nachhinein angehängt werden'],
  },
  Pr: {
    caption: 'Prokrastino',
    image: require('../assets/prokrastino.png'),
    behaviours: ['Du kannst dich oft nicht richtig aufraffen', 'Du schiebst häufig Sachen auf'],
    solutions: ['Feste Einplanung von „Schaffenszeiten“', 'Anreize für Aufgabenerledigung schaffen, z.B. Belohnung', 'Aufgaben in kleine Teilaufgaben einteilen'],
  },
  S: {
    caption: 'Sozialino',
    image: require('../assets/sozialino.png'),
    behaviours: ['Du verquatscht dich häufig', 'Du kümmerst dich lieber um Freunde statt um Aufgaben', 'Viel Kontakt mit Menschen ist für dich sehr wichtig'],
    solutions: ['Vorher feste Zeiten definieren und ankündigen (z.B. 30 Min. gemeinsamer Kaffee, 15 Min. telefonieren)', 'Eigene Prioritäten definieren und abgleichen', '„Zuerst die Arbeit, dann das Vergnügen“-Mentalität etablieren und zur Belohnung Freunde treffen'],
  },
  Z: {
    caption: 'Zerstreulino',
    image: require('../assets/zerstreulino.png'),
    behaviours: ['Du schweifst bei den Sachen, die du tust, häufig ab', 'Du kommst vom Hundertsten ins Tausendste', 'Du „verdattelst“ viel Zeit am Handy und schaust auch oft während anderer Aktivitäten darauf'],
    solutions: ['Pausen und Frischluft einplanen', 'Anzahl an Recherche-Quellen o.ä. vorher festlegen', 'Klare Prioritäten definieren, Belohnung einplanen', 'Aufgaben stellen wie „ich lese diesen Artikel durch“', 'Klare „To-do-Liste“ zum Abhaken o.ä.', 'Schalte dein Handy in Konzentrationsphasen bewusst aus oder lege es in einen anderen Raum'],
  },
};
